goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Home$default");
shadow.js.shim.module$$carbon$icons_react$es$Home$default = shadow.js.require(364, {}).default;
